import { GaPageType, L2Category, L3Category } from '../../types/advertising/partnership';
import { L1Category } from '../../types/client-data';
import { isAnyvanEnabled } from './anyvan';

export enum SelectedPartner {
    NONE = 'NONE',
    ANYVAN = 'ANYVAN',
    JOBS_WIDGET = 'JOBS_WIDGET',
}

export const getSelectedPartner = (
    gaPageType: GaPageType,
    l1Category: L1Category | undefined,
    l2Category: L2Category,
    l3Category: L3Category | undefined
): SelectedPartner => {
    if (isAnyvanEnabled(gaPageType, l1Category, l2Category, l3Category)) {
        return SelectedPartner.ANYVAN;
    }
    return SelectedPartner.NONE;
};
